module.exports = __webpack_public_path__ + "img/noCar.c0922b6d.png";